import Vue from 'vue'
import Vuex from 'vuex'
import { lanterns } from '@/store/lanterns.module'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    mapCenter: null,
    zoom: null,
    mapBounds: null,
    cityName: '',
    cityImage: '',
    cityText: '',
    useCustomMessage: false,
    customMessage: null
  },
  mutations: {
    updateZoom: (state, zoom) => {
      state.zoom = zoom
    },
    updateCenter: (state, center) => {
      state.mapCenter = center
    },
    updateMapBounds: (state, bounds) => {
      state.mapBounds = bounds
    },
    setCityName: (state, name: string) => {
      state.cityName = name
    },
    setCityText: (state, text) => {
      state.cityText = text
    },
    setCityImage: (state, image: string) => {
      state.cityImage = image
    },
    setCityUseCustomMessage: (state, useCustomMessage: boolean) => {
      state.useCustomMessage = useCustomMessage
    },
    setCityCustomMessage: (state, customMessage) => {
      state.customMessage = customMessage
    }
  },
  actions: {},
  modules: {
    lanterns
  }
})
